// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGeocodedForSearchRequest,
  TGeocodedForSearchModel,
  IMappers,
  TGeocodedForSearchResponse,
  TGeocodedForSearchResponse_1,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TGeocodedForSearchModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  method: 'POST',
  microserviceName: 'geo',
  pathApi: '/v1/geocoded-for-search/',
  requestContentType: 'json',
  interserviceAuthEnabled: true,
} as TGeocodedForSearchModel;

export function createGeocodedForSearchModel(parameters: TGeocodedForSearchRequest): TGeocodedForSearchModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGeocodedForSearchOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: TGeocodedForSearchRequest;
}

export async function fetchGeocodedForSearch<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGeocodedForSearchOptions<TResponse200>): Promise<TGeocodedForSearchResponse | TResponse200> {
  const { statusCode, response, headers } = await httpApi.fetch(createGeocodedForSearchModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGeocodedForSearchResponse_1);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGeocodedForSearchResponse;
}
